module.exports = __webpack_public_path__ + "static/5-3-3758d9d5edf92e9c6da6562ec5573354.gif";